module.exports = __webpack_public_path__ + "img/Link.6e6ad709.svg";